import {KoAPI} from "packages";
import { configs } from 'configuration';

const version = configs().API_VERSION;

export const accountAPI = {
   
  login(data) {
    return KoAPI.post(`/api/${version}/account/login`, { data });
  },
  createAccount(data) {
    return KoAPI.post(`/api/${version}/account/signup`, { data });
  },
  verify(data){
    return KoAPI.update(`/api/${version}/account/verify`, { data });
  },
  resedOTP(data){
    return KoAPI.post(`/api/${version}/account/resend/otp`, { data });
  },
  forgotpassword(data){
    return KoAPI.post(`/api/${version}/account/password/forgot`, { data });
  },
  changePassword(data){
    return KoAPI.update(`/api/${version}/account/change/password`, { data });
  },
  resetPassword(data){
    return KoAPI.update(`/api/${version}/account/password/reset`, { data });
  },
  newPassword(data){
    return KoAPI.post(`/api/${version}/account/newpwd`, { data });
  },
  getAccounts(){
    return KoAPI.get(`/api/${version}/account/count`);
  },
  switchAccount(data){
    return KoAPI.post(`/api/${version}/account/switch`, { data });
  },
  getGloableSearchData(query){
    return KoAPI.get(`/api/${version}/workspace/overallSearch`, {query: { ...query } });
  },
  updateFCMToken(data){
    return KoAPI.post(`/api/${version}/notification/token/add`, { data });
  },
  getRecentTickets(q) {
    return KoAPI.get(`/api/${version}/taskplanner/ticket/recent`, { query: { ...q } });
  },
  getgoogleLogin() {
    return KoAPI.get(`/api/${version}/account/google/login`);
  }
};